import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import FormField from '../../../dynamicFormBuilder/FormField'
import data from "../../../assets/apiRoutes.json";
import axios from "axios";
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import { LoadPanel } from 'devextreme-react/load-panel';
import notify from 'devextreme/ui/notify';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import { alert, confirm } from 'devextreme/ui/dialog';
import Toolbar, { Item } from "devextreme-react/toolbar";

import { GetFormatedDateWithTime, FormatPhoneNumber } from '../../../common/Utils'
import HeaderFrom from "../../common/HeaderFrom";
//import AdditionalTab from "../../wm/codes/customerDataEntry/AdditionalTab";
import { custom } from 'devextreme/ui/dialog';
import ValidationSummary from 'devextreme-react/validation-summary';

import ArrayStore from 'devextreme/data/array_store';
import { v4 as uuidv4 } from 'uuid';
import AddressTab from "../../common/AddressTab";
import AlternateAddressTab from "../../common/AlternateAddressTab";
import MasterDataTab from "../../common/MasterDataTab";
import RelationshipLinkList from "../../common/lists/RelationshipLinkList";
import Synonym from "../../common/Synonym";
import UserDefinedTab from "./tabs/UserDefinedTab";
import AdditionalTab from "./tabs/AdditionalTab";
import FrghtRateZonesTab from "./tabs/FrghtRateZonesTab";
import OMDefaultsTab from "./tabs/OMDefaultTab";
import EdiDefaultTab from "./tabs/EdiDefaultTab";
import WMDefaultTab from "./tabs/WMDefaultTab";



var skipDataLoading = false;

function Form(props) {

    const initialFormFields = {
        ROWID: '00000000-0000-0000-0000-000000000000',
        KEYSEQUENCE: 1,
        CREATIONDATETIME: new Date(),
        CREATIONUSERID: '',
        LASTUPDATEDATETIME: new Date(),
        LASTUPDATEUSERID: '',
        COMPANYID: '',
        MODULE: 'ID',
        RECORDTYPE: 'R',
        IDENTITYID: '',
        NAME: '',
        R_DEFAULTADDRESS: null,
        INVISIBLETYPEGUID: '',
        R_PROFILE: null,
        PROFILEGUID: '',
        PROFILECODE: '',
        IDGROUP: '',
        IDSUBGROUP: '',
        REFERENCE1: '',
        REFERENCE2: '',
        DATE1: null,
        DATE2: null,
        R_CONTACT: null,
        COMMENT: '',
        R_IDENTITY: null,
        AddressROWID: '00000000-0000-0000-0000-000000000000',
        AddressCREATIONDATETIME: new Date(),
        AddressLASTUPDATEDATETIME: new Date(),
        AddressADDRESSNAME: '',
        AddressADDRESS1: '',
        AddressADDRESS2: '',
        AddressCITY: '',
        AddressZIP: '',
        AddressCOUNTRY: '',
        AddressTELEPHONE1: '',
        AddressTELEPHONE2: '',
        AddressFAX1: '',
        AddressFAX2: null,
        AddressMODEM1: '',
        AddressMODEM2: '',
        AddressCELLPHONE1: null,
        AddressCELLPHONE2: null,
        AddressPAGER1: null,
        AddressPAGER2: '',
        AddressEMAILADDRESS1: '',
        AddressEMAILADDRESS2: '',
        AddressWEBSITEADDRESS1: '',
        AddressWEBSITEADDRESS2: '',
        AddressSTATE: '',
        AddressALTERNATENAME: '',
        AddressLATITUDE: '',
        AddressLONGITUDE: '',
        AddressCOUNTY: '',

        AlterAddressROWID: '00000000-0000-0000-0000-000000000000',
        AlterAddressCREATIONDATETIME: new Date(),
        AlterAddressLASTUPDATEDATETIME: new Date(),
        AlterAddressNAME: '',
        AlterAddressADDRESSNAME: '',
        AlterAddressADDRESS1: '',
        AlterAddressADDRESS2: '',
        AlterAddressCITY: '',
        AlterAddressZIP: '',
        AlterAddressCOUNTRY: '',
        AlterAddressTELEPHONE1: '',
        AlterAddressTELEPHONE2: '',
        AlterAddressFAX1: '',
        AlterAddressFAX2: null,
        AlterAddressMODEM1: '',
        AlterAddressMODEM2: '',
        AlterAddressCELLPHONE1: null,
        AlterAddressCELLPHONE2: null,
        AlterAddressPAGER1: null,
        AlterAddressPAGER2: '',
        AlterAddressEMAILADDRESS1: '',
        AlterAddressEMAILADDRESS2: '',
        AlterAddressWEBSITEADDRESS1: '',
        AlterAddressWEBSITEADDRESS2: '',
        AlterAddressSTATE: '',
        AlterAddressALTERNATENAME: '',
        AlterAddressLATITUDE: '',
        AlterAddressLONGITUDE: '',
        AlterAddressCOUNTY: '',
        DefAddress: true,
        RECORD: '',
        IDTYPE:'02',
        ConsigneeSTATUS: 'A',
        ConsigneeROWID: '00000000-0000-0000-0000-000000000000',
        ConsigneeCREATIONDATETIME: new Date(),
        ConsigneeLASTUPDATEDATETIME: new Date(),
        ConsigneeCOMMENT: null,
        ConsigneeDIRECTIONS:null,
        ConsigneeCOMPANYID  :'',
        ConsigneeMODULE:'ID',
        ConsigneeRECORDTYPE:'R',
        ConsigneeLOCATION :null,
        ConsigneeSCACCODE :null,
        ConsigneeFMSTOPNO:null,
        ConsigneeDELIVERYROUTE:null,
        ConsigneePOPUPMESSAGE:null,
        ConsigneeUSERDEFINEDCODE_1:  null,
        ConsigneeUSERDEFINEDCODE_2:  null,
        ConsigneeUSERDEFINEDCODE_3:  null,
        ConsigneeUSERDEFINEDCODE_4:  null,
        ConsigneeUSERDEFINEDCODE_5:  null,
        ConsigneeUSERDEFINEDCODE_6:  null,
        ConsigneeUSERDEFINEDCODE_7:  null,
        ConsigneeUSERDEFINEDCODE_8:  null,
        ConsigneeUSERDEFINEDCODE_9:  null,
        ConsigneeUSERDEFINEDCODE_10: null,
        ConsigneeUSERDEFINEDCODE_11: null,
        ConsigneeUSERDEFINEDCODE_12: null,
        ConsigneeUSERDEFINEDCODE_13: null,
        ConsigneeUSERDEFINEDCODE_14: null,
        ConsigneeUSERDEFINEDCODE_15: null,
        ConsigneeUSERDEFINEDCODE_16: null,
        ConsigneeUSERDEFINEDCODE_17: null,
        ConsigneeUSERDEFINEDCODE_18: null,
        ConsigneeUSERDEFINEDCODE_19: null,
        ConsigneeUSERDEFINEDCODE_20: null,
        ConsigneeUSERDEFINEDREFERENCE_1: null,
        ConsigneeUSERDEFINEDREFERENCE_2: null,
        ConsigneeUSERDEFINEDREFERENCE_3: null,
        ConsigneeUSERDEFINEDREFERENCE_4: null,
        ConsigneeUSERDEFINEDREFERENCE_5: null,
        ConsigneeUSERDEFINEDREFERENCE_6: null,
        ConsigneeUSERDEFINEDREFERENCE_7: null,
        ConsigneeUSERDEFINEDREFERENCE_8: null,
        ConsigneeUSERDEFINEDREFERENCE_9: null,
        ConsigneeUSERDEFINEDREFERENCE_10:null,
        ConsigneeUSERDEFINEDREFERENCE_11: null,
        ConsigneeUSERDEFINEDREFERENCE_12: null,
        ConsigneeUSERDEFINEDREFERENCE_13: null,
        ConsigneeUSERDEFINEDREFERENCE_14: null,
        ConsigneeUSERDEFINEDREFERENCE_15: null,
        ConsigneeUSERDEFINEDREFERENCE_16: null,
        ConsigneeUSERDEFINEDREFERENCE_17: null,
        ConsigneeUSERDEFINEDREFERENCE_18: null,
        ConsigneeUSERDEFINEDREFERENCE_19: null,
        ConsigneeUSERDEFINEDREFERENCE_20: null,
        ConsigneeUSERDEFINEDDATE_1: null,
        ConsigneeUSERDEFINEDDATE_2: null,
        ConsigneeUSERDEFINEDDATE_3: null,
        ConsigneeUSERDEFINEDDATE_4: null,
        ConsigneeUSERDEFINEDDATE_5: null,
        ConsigneeUSERDEFINEDDATE_6: null,
        ConsigneeUSERDEFINEDDATE_7: null,
        ConsigneeUSERDEFINEDDATE_8: null,
        ConsigneeUSERDEFINEDDATE_9: null,
        ConsigneeUSERDEFINEDDATE_10: null,
        ConsigneeUSERDEFINEDDATE_11: null,
        ConsigneeUSERDEFINEDDATE_12: null,
        ConsigneeUSERDEFINEDDATE_13: null,
        ConsigneeUSERDEFINEDDATE_14: null,
        ConsigneeUSERDEFINEDDATE_15: null,
        ConsigneeUSERDEFINEDDATE_16: null,
        ConsigneeUSERDEFINEDDATE_17: null,
        ConsigneeUSERDEFINEDDATE_18: null,
        ConsigneeUSERDEFINEDDATE_19: null,
        ConsigneeUSERDEFINEDDATE_20: null,
        ConsigneeUSERDEFINEDCOMMENT: '',
        ConsigneeUSERDEFINEDQUANTITY_1: null,
        ConsigneeUSERDEFINEDQUANTITY_2: null,
        ConsigneeUSERDEFINEDQUANTITY_3: null,
        ConsigneeUSERDEFINEDQUANTITY_4: null,
        ConsigneeUSERDEFINEDQUANTITY_5: null,
        ConsigneeUSERDEFINEDQUANTITY_6: null,
        ConsigneeUSERDEFINEDQUANTITY_7: null,
        ConsigneeUSERDEFINEDQUANTITY_8: null,
        ConsigneeUSERDEFINEDQUANTITY_9: null,
        ConsigneeUSERDEFINEDQUANTITY_10: null,

        ConsigneeUSERDEFINEDQUANTITY_11: null,
        ConsigneeUSERDEFINEDQUANTITY_12: null,
        ConsigneeUSERDEFINEDQUANTITY_13: null,
        ConsigneeUSERDEFINEDQUANTITY_14: null,
        ConsigneeUSERDEFINEDQUANTITY_15: null,
        ConsigneeUSERDEFINEDQUANTITY_16: null,
        ConsigneeUSERDEFINEDQUANTITY_17: null,
        ConsigneeUSERDEFINEDQUANTITY_18: null,
        ConsigneeUSERDEFINEDQUANTITY_19: null,
        ConsigneeUSERDEFINEDQUANTITY_20: null,
        ConsigneeSOINVENTORYPRICELEVEL: null,
        ConsigneeRPRICESCHEDULE: null,
        ConsigneeRSHIPVIA: null,
        ConsigneeRPARTICIPANT:null,
        ConsigneeRPRODUCTCATEGORY:null,
        ConsigneeRTAX:null,
        ConsigneeRDEPARTMENT:null,
        ConsigneeRFUND:null,
        ConsigneeRJOB:null,
        ConsigneeOMVISIBLE:null,
        ConsigneeRWHITEM:null,
        ConsigneeRWHLOCATION:null,
        ConsigneeCONSIGNMENTUNITS:null,
        ConsigneeRCONSIGNMENTPRODUCTCATEGORY:null,
        ConsigneeRTRADINGPARTNER:null,
        ConsigneeIDQUALIFIER:null,
        ConsigneeIDCODE:null,
        ConsigneeLOCATIONQUALIFIER :null,
        ConsigneeLOCATIONIDENTIFIER:null,
        ConsigneeWMEXPIRATIONDAYS:null,
       
    };
    const history = useHistory();
    const IdType ="02";
    var accessToken = props.oidc.user.access_token;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [formFields, setformFields] = useState(initialFormFields);

    const [omDefaultRef, setOmDefaultRef] = useState(null);
    const [reportFormats, setReportFormats] = useState({ pickingSlipFormat: '', InvoiceFormat: '', OrderAcknFormat: '' });


    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, [setLoadPanelVisible]);
    const position = { of: '#accordion-containe2' };
    var currentUser = props.oidc.user;
    const formRefs = useRef({});

    let consigneeRowId = null;
    let addressId = null;
    const handleFormSubmit = async (e) => {
        setLoadPanelVisible(true);
        setIsFormSubmitted(true);
        try {
            e.preventDefault();
            if (formFields.ROWID == "00000000-0000-0000-0000-000000000000") {
                await postTransaction();
            }
            else {
                await updateTransaction();
            }

        } catch (error) {
            console.error('Error submitting form:', error);
            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };

    const postTransaction = async () => {
        try {
            const url = "id/Consignee/InsertConsignee";
            let fields = formFields;
            fields.DefAddress = fields.DefAddress ?? true;
            fields.DATE1 = GetFormatedDateWithTime(formFields.DATE1);
            fields.DATE2 = GetFormatedDateWithTime(formFields.DATE2);
            fields.RECORDTYPE = 'R';
            fields.ConsigneeUSERDEFINEDDATE_1 = GetFormatedDateWithTime(formFields.ConsigneeUSERDEFINEDDATE_1);
            fields.ConsigneeUSERDEFINEDDATE_2 = GetFormatedDateWithTime(formFields.ConsigneeUSERDEFINEDDATE_2);
            fields.ConsigneeUSERDEFINEDDATE_3 = GetFormatedDateWithTime(formFields.ConsigneeUSERDEFINEDDATE_3);
            fields.ConsigneeUSERDEFINEDDATE_4 = GetFormatedDateWithTime(formFields.ConsigneeUSERDEFINEDDATE_4);
            fields.ConsigneeUSERDEFINEDDATE_5 = GetFormatedDateWithTime(formFields.ConsigneeUSERDEFINEDDATE_5);
            fields.ConsigneeUSERDEFINEDDATE_6 = GetFormatedDateWithTime(formFields.ConsigneeUSERDEFINEDDATE_6);
            fields.ConsigneeUSERDEFINEDDATE_7 = GetFormatedDateWithTime(formFields.ConsigneeUSERDEFINEDDATE_7);
            fields.ConsigneeUSERDEFINEDDATE_8 = GetFormatedDateWithTime(formFields.ConsigneeUSERDEFINEDDATE_8);
            fields.ConsigneeUSERDEFINEDDATE_9 = GetFormatedDateWithTime(formFields.ConsigneeUSERDEFINEDDATE_9);
            fields.ConsigneeUSERDEFINEDDATE_10 = GetFormatedDateWithTime(formFields.ConsigneeUSERDEFINEDDATE_10);
            fields.ConsigneeUSERDEFINEDDATE_11 = GetFormatedDateWithTime(formFields.ConsigneeUSERDEFINEDDATE_11);
            fields.ConsigneeUSERDEFINEDDATE_12 = GetFormatedDateWithTime(formFields.ConsigneeUSERDEFINEDDATE_12);
            fields.ConsigneeUSERDEFINEDDATE_13 = GetFormatedDateWithTime(formFields.ConsigneeUSERDEFINEDDATE_13);
            fields.ConsigneeUSERDEFINEDDATE_14 = GetFormatedDateWithTime(formFields.ConsigneeUSERDEFINEDDATE_14);
            fields.ConsigneeUSERDEFINEDDATE_15 = GetFormatedDateWithTime(formFields.ConsigneeUSERDEFINEDDATE_15);
            fields.ConsigneeUSERDEFINEDDATE_16 = GetFormatedDateWithTime(formFields.ConsigneeUSERDEFINEDDATE_16);
            fields.ConsigneeUSERDEFINEDDATE_17 = GetFormatedDateWithTime(formFields.ConsigneeUSERDEFINEDDATE_17);
            fields.ConsigneeUSERDEFINEDDATE_18 = GetFormatedDateWithTime(formFields.ConsigneeUSERDEFINEDDATE_18);
            fields.ConsigneeUSERDEFINEDDATE_19 = GetFormatedDateWithTime(formFields.ConsigneeUSERDEFINEDDATE_19);
            fields.ConsigneeUSERDEFINEDDATE_20 = GetFormatedDateWithTime(formFields.ConsigneeUSERDEFINEDDATE_20);
            fields.IDTYPE='02';
            const response = await axios.post(`${window._env_.REACT_APP_APIS}/${url}`, fields, {
                headers: {
                    'Content-Type': 'application/json',
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });
            if (!response.data.ERRORS.length > 0) {
                addressId = response.data.AddressROWID;
                consigneeRowId = response.data.EntityROWID;
                setformFields(prevFields => ({
                    ...prevFields,
                    ROWID: response.data.ROWID,
                    R_IDENTITY: response.data.ROWID,
                    RECORD: response.data.RECORD,
                    AddressROWID: response.data.AddressROWID,
                    R_DEFAULTADDRESS: response.data.AddressROWID,
                    ConsigneeROWID: response.data.EntityROWID,
                    AlterAddressROWID: response.data.AlterAddressROWID,
                }));
                notify(
                    {
                        message: "Consignee Created",
                        width: 100,
                    },
                    'success',
                    3000,
                );
                setIsFormSubmitted(false);
            } else {
                const errorHtml = response.data.ERRORS.map(err => `<div>${err}</div>`).join('');
                custom({
                    title: "Errors",
                    messageHtml: errorHtml,
                    buttons: [{ text: "OK", onClick: () => { } }]
                }).show();

                setIsFormSubmitted(false);
            }

        } catch (error) {
            console.error('Error submitting form:', error);
            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };
    const updateTransaction = async () => {
        try {
            const url = "id/Consignee/UpdateConsignee";
            let fields = formFields;
            fields.DefAddress = fields.DefAddress ?? true;
            if (fields.AlterAddressROWID === null)
                fields.AlterAddressROWID = initialFormFields.AlterAddressROWID;

            fields.DATE1 = GetFormatedDateWithTime(formFields.DATE1);
            fields.DATE2 = GetFormatedDateWithTime(formFields.DATE2);
            fields.ConsigneeUSERDEFINEDDATE_1 = GetFormatedDateWithTime(formFields.ConsigneeUSERDEFINEDDATE_1);
            fields.ConsigneeUSERDEFINEDDATE_2 = GetFormatedDateWithTime(formFields.ConsigneeUSERDEFINEDDATE_2);
            fields.ConsigneeUSERDEFINEDDATE_3 = GetFormatedDateWithTime(formFields.ConsigneeUSERDEFINEDDATE_3);
            fields.ConsigneeUSERDEFINEDDATE_4 = GetFormatedDateWithTime(formFields.ConsigneeUSERDEFINEDDATE_4);
            fields.ConsigneeUSERDEFINEDDATE_5 = GetFormatedDateWithTime(formFields.ConsigneeUSERDEFINEDDATE_5);
            fields.ConsigneeUSERDEFINEDDATE_6 = GetFormatedDateWithTime(formFields.ConsigneeUSERDEFINEDDATE_6);
            fields.ConsigneeUSERDEFINEDDATE_7 = GetFormatedDateWithTime(formFields.ConsigneeUSERDEFINEDDATE_7);
            fields.ConsigneeUSERDEFINEDDATE_8 = GetFormatedDateWithTime(formFields.ConsigneeUSERDEFINEDDATE_8);
            fields.ConsigneeUSERDEFINEDDATE_9 = GetFormatedDateWithTime(formFields.ConsigneeUSERDEFINEDDATE_9);
            fields.ConsigneeUSERDEFINEDDATE_10 = GetFormatedDateWithTime(formFields.ConsigneeUSERDEFINEDDATE_10);
            fields.ConsigneeUSERDEFINEDDATE_11 = GetFormatedDateWithTime(formFields.ConsigneeUSERDEFINEDDATE_11);
            fields.ConsigneeUSERDEFINEDDATE_12 = GetFormatedDateWithTime(formFields.ConsigneeUSERDEFINEDDATE_12);
            fields.ConsigneeUSERDEFINEDDATE_13 = GetFormatedDateWithTime(formFields.ConsigneeUSERDEFINEDDATE_13);
            fields.ConsigneeUSERDEFINEDDATE_14 = GetFormatedDateWithTime(formFields.ConsigneeUSERDEFINEDDATE_14);
            fields.ConsigneeUSERDEFINEDDATE_15 = GetFormatedDateWithTime(formFields.ConsigneeUSERDEFINEDDATE_15);
            fields.ConsigneeUSERDEFINEDDATE_16 = GetFormatedDateWithTime(formFields.ConsigneeUSERDEFINEDDATE_16);
            fields.ConsigneeUSERDEFINEDDATE_17 = GetFormatedDateWithTime(formFields.ConsigneeUSERDEFINEDDATE_17);
            fields.ConsigneeUSERDEFINEDDATE_18 = GetFormatedDateWithTime(formFields.ConsigneeUSERDEFINEDDATE_18);
            fields.ConsigneeUSERDEFINEDDATE_19 = GetFormatedDateWithTime(formFields.ConsigneeUSERDEFINEDDATE_19);
            fields.ConsigneeUSERDEFINEDDATE_20 = GetFormatedDateWithTime(formFields.ConsigneeUSERDEFINEDDATE_20);
            fields.IDTYPE='02';

            if (addressId !== null) { fields.AddressROWID = addressId; }
            if (consigneeRowId !== null) { fields.ConsigneeROWID = consigneeRowId; }

            const response = await axios.put(`${window._env_.REACT_APP_APIS}/${url}`, fields, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });
            if (!response.data.ERRORS.length > 0) {
                setformFields(prevFields => ({
                    ...prevFields,
                    AlterAddressROWID: response.data.AlterAddressROWID,
                }));
                notify(
                    {
                        message: "Consignee Data Entry Updated",
                        width: 100,
                    },
                    'success',
                    3000,
                );
                setIsFormSubmitted(false);
            } else {
                const errorHtml = response.data.ERRORS.map(err => `<div>${err}</div>`).join('');
                custom({
                    title: "Errors",
                    messageHtml: errorHtml,
                    buttons: [{ text: "OK", onClick: () => { } }]
                }).show();

                setIsFormSubmitted(false);
            }

        } catch (error) {
            console.error('Error submitting form:', error);
            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };

    const primaryFormLookupsLoad = (formRefs) => {
        primaryFormLoad(formRefs);
        omDefaultsFormLookupsLoad(formRefs);
    }
    const userDefinedFormLookupsLoad = (formRefs) => {
       
    };
        const additonalFormLookupsLoad = (formRefs) => {
       loadLookupFromStaticData(formRefs, "ConsigneeSTATUS", [{ id: 'A', name: "Active" }, { id: 'I', name: "Inactive" }]);
    };
    const primaryFormLoad = (formRefs) => {
  

        if (formRefs.current['RECORD']) {
            formRefs.current['RECORD'].instance().option('disabled', true);
        }
    }
    const oMDefaultsSelectionChanged = (formRefs, name, value,text=null,formatCaption=null,chargeuom=null) => {
 
    }
    const omDefaultsFormLookupsLoad = (formRefs) => {
        const priceLevels = [{ id: 'A', name: "Price Level - A" }, { id: 'B', name: "Price Level - B" }, { id: 'C', name: "Price Level - C" }, { id: 'D', name: "Price Level - D" }, { id: 'E', name: "Price Level - E" },
        { id: 'F', name: "Price Level - F" }, { id: 'G', name: "Price Level - G" }, { id: 'H', name: "Price Level - H" }, { id: 'I', name: "Price Level - I" }, { id: 'J', name: "Price Level - J" }, { id: 'K', name: "Price Level - K" }, { id: 'L', name: "Price Level - L" }, { id: 'M', name: "Price Level - M" },
        { id: 'N', name: "Price Level - N" }, { id: 'O', name: "Price Level - O" }, { id: 'P', name: "Price Level - P" }, { id: 'Q', name: "Price Level - Q" }, { id: 'R', name: "Price Level - R" },
        { id: 'S', name: "Price Level - S" }, { id: 'T', name: "Price Level - T" }, { id: 'U', name: "Price Level - U" }, { id: 'V', name: "Price Level - V" }, { id: 'X', name: "Price Level - X" },
        { id: 'Y', name: "Price Level - Y" }, { id: 'Z', name: "Price Level - Z" }
        ];
        const yesNo = [{ id: 'Y', name: "Yes" }, { id: 'N', name: "No" }];
        loadLookupFromStaticData(formRefs, "ConsigneeOMVISIBLE", yesNo);
        const convertUnitsOptions = [{ id: 'P', name: "To Pieces" }, { id: 'N', name: "No" }];
        loadLookupFromStaticData(formRefs, "ConsigneeCONSIGNMENTUNITS", convertUnitsOptions);
        loadLookupFromStaticData(formRefs, "ConsigneeSOINVENTORYPRICELEVEL", priceLevels);
        setOmDefaultRef(formRefs);
    }

    const loadLookupFromCodesDataSource = (formRefs, type, name) => {
        const dataSource = GetCodeByType(type);
        if (formRefs.current[name]) {
            formRefs.current[name].instance().option('dataSource', dataSource);
            formRefs.current[name].instance().option('valueExpr', 'name');
            formRefs.current[name].instance().option('displayExpr', 'name');
            formRefs.current[name].instance().option('value', formFields[name]);
        }
    };
    const GetCodeByType = (type) => {
        const items = new DataSource({
            store: createStore({
                loadUrl: `${window._env_.REACT_APP_APIS}/${data.ID.GetIDCodes}`,
                key: 'name',
                loadParams: {
                    codeType: type,
                },
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            sort: [{ selector: "name", desc: false }],
            paginate: true,
            pageSize: 100
        });
        return items;
    };
    const loadLookupFromStaticData = (formRefs, name, dataSource) => {
        if (formRefs.current[name]) {
            formRefs.current[name].instance().option('dataSource', dataSource);
            formRefs.current[name].instance().option('valueExpr', 'id');
            formRefs.current[name].instance().option('displayExpr', 'name');
            if (formFields[name])
                formRefs.current[name].instance().option('value', formFields[name]);
        }

    };
    const loadLookupFromDataSource = (formRefs, name, url, valueExpr, displayExpr, loadParams = null) => {
        var dataSource = new DataSource({
            store: new createStore({
                key: valueExpr,
                loadUrl: url,
                loadParams: loadParams,
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            sort: [{ selector: displayExpr, desc: false }],
            paginate: true,
            pageSize: 100
        });
        if (formRefs.current[name]) {
            formRefs.current[name].instance().option('dataSource', dataSource);
            formRefs.current[name].instance().option('valueExpr', valueExpr);
            formRefs.current[name].instance().option('displayExpr', displayExpr);
            if (formFields[name])
                formRefs.current[name].instance().option('value', formFields[name]);
        }
    };



    const handleReset = () => {

        var rowid = props.id;
        if (rowid != null && rowid != undefined && rowid != '') {
            GetHeaderInfoById(rowid);
        }
        else {
            skipDataLoading = true;
            setformFields(initialFormFields);
            skipDataLoading = false;
            EnableControlsForNewRecord();
        }

    };

    const DeleteClick = async () => {
        let result = confirm("<i>Are your sure you want to delete this record?</i>", "Delete");
        result.then(async (dialogResult) => {
            if (dialogResult) {
                setLoadPanelVisible(true);
                const response = await axios.post(`${window._env_.REACT_APP_APIS}/${data.ID.DeleteCustomerDataEntry}`, formFields.ROWID, {
                    headers: {
                        'Content-Type': 'application/json',
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`
                    },
                });
                if (!response.data.ERRORS.length > 0) {
                    notify(
                        {
                            message: "Consignee Deleted",
                            width: 100,
                        },
                        'success',
                        3000,
                    );
                    setLoadPanelVisible(false);
                    history.push('/wm/codes/consignee-data-entry');
                } else {
                    setLoadPanelVisible(false);
                    const errorHtml = response.data.ERRORS.map(err => `<div>${err}</div>`).join('');
                    custom({
                        title: "Errors",
                        messageHtml: errorHtml,
                        buttons: [{ text: "OK", onClick: () => { } }]
                    }).show();
                }
            }
        })
    }
    const addNewRecordClick = () => {
        setIsFormSubmitted(false);
        skipDataLoading = true;
        setformFields(initialFormFields);
        skipDataLoading = false;
        history.push('/wm/codes/add-consignee');
        EnableControlsForNewRecord();
    }

    const GetHeaderInfoById = (id) => {
        try {
            setLoadPanelVisible(true);
            const response = axios.get(`${window._env_.REACT_APP_APIS}/${data.ID.GetConsigneeDataByRowId}?rowid=${id}`, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            }).then((res) => {
                const responseData = res.data;
                if (responseData && responseData.ROWID) {
                    skipDataLoading = true;
                    setformFields(responseData);
                    skipDataLoading = false;
                    if (formRefs.current["R_PROFILE"]) {
                        formRefs.current["R_PROFILE"].instance().option('disabled', true);
                    }
                }
                else {
                    console.error('Failed to get transaction data');
                }
            });


        } catch (error) {
            console.error('Error failed to get transaction data:', error);
        } finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };

    useEffect(() => {
        var rowid = props.id;
        if (rowid != null && rowid != undefined && rowid != '') {
            GetHeaderInfoById(rowid);
        }
    }, []);

    const goBack = () => {
        history.push("/wm/codes/consignee-data-entry");
    };

    const EnableControlsForNewRecord = () => {

        if (formRefs.current["R_PROFILE"]) {
            formRefs.current["R_PROFILE"].instance().option('disabled', false);
        }

        if (formRefs.current["R_CUSTOMER"]) {
            formRefs.current["R_CUSTOMER"].instance().option('disabled', false);
        }

        if (formRefs.current["TRANSACTIONTYPE"]) {
            formRefs.current["TRANSACTIONTYPE"].instance().option('disabled', false);
        }
    }

    const GetCustomerDataFromProfile = async (profileId) => {
        if (profileId === null)
            return;
        setLoadPanelVisible(true);
        try {
            const response = await axios.get(`${window._env_.REACT_APP_APIS}/${data.ID.GetConsigneeDataByRowId}`, {
                method: 'GET',
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            });

            if (response.hasOwnProperty("data") && response.data != null && response.data != undefined && response.data != "") {
                if (response.data) {
                 let responseData=response.data
                    responseData.ROWID = '00000000-0000-0000-0000-000000000000';
                    responseData.AddressROWID = '00000000-0000-0000-0000-000000000000';
                    responseData.AlterAddressROWID = '00000000-0000-0000-0000-000000000000';
                    responseData.ConsigneeROWID = '00000000-0000-0000-0000-000000000000';
                    responseData.RECORD = '';
                    responseData.CREATIONDATETIME = null;
                    responseData.LASTUPDATEDATETIME = null;
                    responseData.AlterAddressCREATIONDATETIME = null;
                    responseData.AddressLASTUPDATEDATETIME = null;
                    responseData.AddressCREATIONDATETIME = null;
                    responseData.ConsigneeCREATIONDATETIME = null;
                    responseData.ConsigneeLASTUPDATEDATETIME = null;

                    responseData.CREATIONUSERID =  '';
                    responseData.LASTUPDATEUSERID =  '';
                    responseData.COMPANYID =  '';
                    responseData.MODULE =  'ID';
                    responseData.RECORDTYPE =  'R';
                    responseData.IDTYPE="02";

                    setformFields(responseData);
                }
            }
            else {
                console.error('Failed to get transaction profile data');
            }
        } catch (error) {
            console.error('Error fetching transaction profile data:', error);
        } finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };
    const handleFieldChange = useCallback((name, value, e) => {
        if (name == "R_PROFILE" && !skipDataLoading) {
            GetCustomerDataFromProfile(value);
        }
    });
    const getFormats = () => {
        let SReport = '';
        if (reportFormats.pickingSlipFormat !== '') {
            if (formFields.CustomerOMPICKINGSLIPREPORTTYPE === 'C') {
                let f = reportFormats.pickingSlipFormat.split('||');
                SReport += f[2] + '\r\n';
            }
            else {
                SReport += reportFormats.pickingSlipFormat + '\r\n';
            }
        }
        else {
            SReport += '\r\n';
        }
        if (reportFormats.InvoiceFormat !== '') {
            if (formFields.CustomerOMINVOICEREPORTTYPE === 'C') {
                let f = reportFormats.InvoiceFormat.split('||');
                SReport += f[2] + '\r\n';
            }
            else {
                SReport += reportFormats.InvoiceFormat + '\r\n';
            }
        }
        else {
            SReport += '\r\n';
        }
        if (reportFormats.OrderAcknFormat !== '') {
            if (formFields.CustomerOMORDERACKNREPORTTYPE === 'C') {
                let f = reportFormats.OrderAcknFormat.split('||');
                SReport += f[2] + '\r\n';
            }
            else {
                SReport += reportFormats.OrderAcknFormat + '\r\n';
            }
        }
        return SReport;
    }

    return (
        <div>
            <div className="row dataEntryMainPage">
                <div className="col-md-12 main-page">
                    <div id="accordion">
                        <LoadPanel
                            shadingColor="rgba(0,0,0,0.4)"
                            position={position}
                            onHiding={hideLoadPanel}
                            visible={loadPanelVisible}
                            showIndicator={true}
                            shading={true}
                            showPane={true}
                            hideOnOutsideClick={false}
                        />
                        <form onSubmit={(e) => handleFormSubmit(e)}>
                            <Toolbar className="header">
                                <Item location="before">
                                    <div className="title">
                                        <h6
                                            style={{
                                                color: window._env_.Color2,
                                                marginLeft: '12px'
                                            }}
                                        >
                                           Consignee Data Entry
                                        </h6>
                                    </div>
                                </Item>
                                <Item location="after">
                                    <Button
                                        text="Save"
                                        useSubmitBehavior={true}
                                        disabled={isFormSubmitted}
                                        type="default"
                                        className="accordianButton"
                                    />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={addNewRecordClick} text="New" type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={DeleteClick} text="Delete" disabled={formFields.ROWID === "00000000-0000-0000-0000-000000000000"} type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={goBack} text="Back" />
                                </Item>
                            </Toolbar>
                            <TabPanel  showNavButtons={true} height={"auto"}>
                                <TabItem title="Primary">
                                    <HeaderFrom formFields={formFields} setformFields={setformFields} handleFieldChange={handleFieldChange} primaryFormLookupsLoad={primaryFormLookupsLoad} IdType={IdType}/>
                                </TabItem>
                                <TabItem title="Def Address" >
                                    <AddressTab formFields={formFields} setformFields={setformFields} />
                                </TabItem>
                                <TabItem title="Alternate Address" >
                                    <AlternateAddressTab formFields={formFields} setformFields={setformFields} IdType={IdType}/>
                                </TabItem>
                                <TabItem title="Additional">
                                <AdditionalTab formFields={formFields} setformFields={setformFields} additonalFormLookupsLoad={additonalFormLookupsLoad}/>
                                </TabItem>
                                <TabItem title="User Defined">
                                 <UserDefinedTab formFields={formFields} setformFields={setformFields} userDefinedFormLookupsLoad={userDefinedFormLookupsLoad}/>
                                </TabItem>
                                <TabItem title="EDI Defaults">
                                  <EdiDefaultTab formFields={formFields} setformFields={setformFields} />
                                </TabItem>
                                <TabItem title="WM Defaults">
                                  <WMDefaultTab formFields={formFields} setformFields={setformFields} />
                                </TabItem>
                                <TabItem title="OM Defaults">
                                     <OMDefaultsTab formFields={formFields} setformFields={setformFields} omDefaultsFormLookupsLoad={omDefaultsFormLookupsLoad} oMDefaultsSelectionChanged={oMDefaultsSelectionChanged}/>
                                </TabItem>
                                <TabItem title="Frght Rate Zones">
                                <FrghtRateZonesTab headerId={formFields.ROWID} disabled={formFields.ROWID==='00000000-0000-0000-0000-000000000000'}/>
                                </TabItem>
                                    <TabItem title="Contact" disabled={formFields.ROWID==='00000000-0000-0000-0000-000000000000'}>
                                        <MasterDataTab RIDMaster={formFields.ROWID} IDType={IdType} IDMemeberType='22' TabName="Contact"
                                        gridKey='275C96CD-E464-45E9-9B41-95E084F83D26'/>
                                    </TabItem>
                                    <TabItem title="All Contacts" disabled={formFields.ROWID==='00000000-0000-0000-0000-000000000000'}>
                                        <MasterDataTab RIDMaster={formFields.ROWID} IDType={IdType} IDMemeberType='22' TabName="AllContacts" 
                                         gridKey='BCDFA379-D6D9-4B2F-8E9B-13896CE767EF'/>
                                    </TabItem>
                                    <TabItem title="Customer" disabled={formFields.ROWID==='00000000-0000-0000-0000-000000000000'}>
                                        <RelationshipLinkList  gridKey="9309CA0F-2521-4108-9811-EA067C03BFF4" formFields={formFields} IdMemberType={IdType} IdMasterType={IdType} LookupUrl="id/Lookup/GetCustomers" Editable={true} />
                                    </TabItem>
                                    <TabItem title="Synonyms" disabled={formFields.ROWID==='00000000-0000-0000-0000-000000000000'}>
                                        <Synonym  gridKey="F105A7EB-5B31-4E9D-9DD0-21FD290B4246" formFields={formFields} IdType={IdType}></Synonym>
                                    </TabItem>
                            </TabPanel>
                            <div className="row">
                                <ValidationSummary className="pl-3 pt-1" id="summary" />
                            </div>
                        </form>
                    </div>

                </div>
            </div>

        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(Form);
